import { render, staticRenderFns } from "./BillInvoiceDetails.vue?vue&type=template&id=3246edba"
import script from "./BillInvoiceDetails.vue?vue&type=script&lang=js"
export * from "./BillInvoiceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports